import { IUserPutPayload, UserService } from '@/app/services/user'
import { ErrorResponse, IApiIndividualResponse } from '@/types/api'
import { IUser } from '@/types/user'

import { UseMutationOptions, useMutation } from 'react-query'

export function useUserMutation(
  userId: string,
  options: Omit<
    UseMutationOptions<
      IApiIndividualResponse<IUser>,
      ErrorResponse,
      IUserPutPayload
    >,
    'mutationKey' | 'mutationFn'
  > = {}
) {
  return useMutation<IApiIndividualResponse<IUser>, ErrorResponse, IUserPutPayload>(
    UserService.getUserPutPath(userId),
    (payload) => UserService.putUser(userId, payload),
    options
  )
}
